import { useEffect, useRef } from "react";

function addEventListener(element, type, listener, options) {
  element.addEventListener(type, listener, options);

  return function removeEventListener() {
    element.removeEventListener(type, listener, options);
  };
}

function useOutsideClick(elementRef, onOutsideClick, useCapture = true) {
  const unsubscribeOnMouseDownRef = useRef();
  const unsubscribeOnMouseUpRef = useRef();

  function subscribeOnMouseDown() {
    unsubscribeOnMouseDown();

    unsubscribeOnMouseDownRef.current = addEventListener(
      document,
      "mousedown",
      onMouseDown,
      { capture: useCapture }
    );
  }

  function subscribeOnMouseUp() {
    unsubscribeOnMouseUp();

    unsubscribeOnMouseUpRef.current = addEventListener(
      document,
      "mouseup",
      onMouseUp,
      { capture: useCapture }
    );
  }

  function unsubscribeOnMouseDown() {
    if (unsubscribeOnMouseDownRef.current) {
      unsubscribeOnMouseDownRef.current();
      unsubscribeOnMouseDownRef.current = null;
    }
  }

  function unsubscribeOnMouseUp() {
    if (unsubscribeOnMouseUpRef.current) {
      unsubscribeOnMouseUpRef.current();
      unsubscribeOnMouseUpRef.current = null;
    }
  }

  function onMouseDown(event) {
    const isDescendantOfRoot =
      elementRef.current && elementRef.current.contains(event.target);

    if (!isDescendantOfRoot) {
      unsubscribeOnMouseUp();
      subscribeOnMouseUp();
    }
  }

  function onMouseUp(event) {
    const isDescendantOfRoot =
      elementRef.current && elementRef.current.contains(event.target);

    unsubscribeOnMouseUp();

    if (!isDescendantOfRoot) {
      onOutsideClick(event);
    }
  }

  useEffect(() => {
    subscribeOnMouseDown();

    return () => {
      unsubscribeOnMouseDown();
      unsubscribeOnMouseUp();
    };
  });

  return elementRef;
}

export default useOutsideClick;
